import React from 'react'
import { AppContainer, Header } from '@templatean/shared/components'
import SlideLibrary from '../components/SlideLibrary'

const SlideTemplatesPage: React.FC = () => {
  return (
    <AppContainer>
      <Header 
        title="Slide Templates"
        subtitle="Professional slide designs for every need"
      />
      
      <div className="page-content">
        <SlideLibrary />
      </div>
    </AppContainer>
  )
}

export default SlideTemplatesPage